import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const tournamentsApi = createApi({
  reducerPath: "tournamentsApi",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_DEV_BASE_URL,
    prepareHeaders: (headers, { getState }) => {
      // Extract authentication token from Redux store
      const token = getState().user.token;

      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),

  endpoints: (builder) => ({
    getTournamentLogo: builder.query({
      query: () => ({
        url: `tournament/logo`,
      }),
    }),
    getTournamentBanner: builder.query({
      query: () => ({
        url: `/tournament/banner`,
      }),
    }),
    uploadLogo: builder.mutation({
      query: (data) => ({
        url: `/tournament/logo`,
        method: "POST",
        headers: {
          "Content-Type": "multipart/form-data",
        },
        body: { data },
      }),
    }),
    createTournament: builder.mutation({
      query: (payload) => ({
        url: `tournament/create`,
        method: "POST",
        body: payload,
      }),
    }),
    editTournament: builder.mutation({
      query: (payload) => ({
        url: `tournament/edit/${payload.params}`,
        method: "POST",
        body: payload.body,
      }),
    }),
    getAllGround: builder.query({
      query: () => ({
        url: `/ground/getGrounds`,
      }),
    }),
    getMyTournament: builder.mutation({
      query: (payload) => ({
        url: `tournament/myTournament`,
        method: "POST",
        body: payload,
      }),
    }),
    followTournament: builder.mutation({
      query: (payload) => ({
        url: `tournament/follow`,
        method: "POST",
        body: payload,
      }),
    }),
    unFollowTournament: builder.mutation({
      query: (payload) => ({
        url: `tournament/unfollow`,
        method: "POST",
        body: payload,
      }),
    }),

    tournamentAddTeam: builder.mutation({
      query: (payload) => ({
        url: `tournament/addTeams`,
        method: "PUT",
        body: payload,
      }),
    }),
    tournamentMatches: builder.query({
      query: (payload) => ({
        url: `/match/my-matches?tournamentId=${payload.tournamentId}`,
      }),
    }),
    leaderBoard: builder.mutation({
      query: (payload) => ({
        url: `tournament/leaderboard`,
        method: "POST",
        body: payload,
      }),
    }),
    getPointsTable: builder.query({
      query: (payload) => ({
        url: `/tournament/pointsTable/${payload}`,
      }),
    }),
    deletePlayer: builder.mutation({
      query: (payload) => ({
        url: `tournament/removePlayer`,
        method: "POST",
        body: payload,
      }),
    }),
    getSpecificTournament: builder.query({
      query: (payload) => ({
        url: `/tournament/detail?tournamentId=${payload.tournamentId}`,
      }),
    }),
  }),
});

export const {
  useGetTournamentLogoQuery,
  useGetTournamentBannerQuery,
  useUploadLogoMutation,
  useCreateTournamentMutation,
  useGetAllGroundQuery,
  useGetMyTournamentMutation,
  useFollowTournamentMutation,
  useUnFollowTournamentMutation,
  useTournamentAddTeamMutation,
  useTournamentMatchesQuery,
  useLeaderBoardMutation,
  useGetPointsTableQuery,
  useDeletePlayerMutation,
  useEditTournamentMutation,
  useLazyGetSpecificTournamentQuery,
} = tournamentsApi;
